import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

export interface SectionHeaderProps {
  title: string;
  /** Route for the optional "See all" link on the right. */
  to?: string;
  seeAllLabel?: string;
  className?: string;
  /**
   * Let a long title wrap onto more lines instead of being cut with an
   * ellipsis, for titles whose end matters ("Other Junaid Jamshed stores in
   * Rawalpindi" on a phone).
   */
  wrap?: boolean;
}

const cn = (...classes: Array<string | false | null | undefined>) =>
  classes.filter(Boolean).join(' ');

/** Section title with the brand red indicator bar and optional "See all" link. */
export function SectionHeader({
  title,
  to,
  seeAllLabel = 'See all',
  className,
  wrap = false,
}: SectionHeaderProps) {
  return (
    <div className={cn('flex items-center justify-between gap-4', className)}>
      {/* A wrapped title keeps the bar beside its first line (28px line, 18px bar). */}
      <div className={cn('flex min-w-0 gap-2.5', wrap ? 'items-start' : 'items-center')}>
        <span
          aria-hidden="true"
          className={cn('h-[18px] w-1 shrink-0 rounded-full bg-primary', wrap && 'mt-[5px]')}
        />
        <h2
          className={cn(
            'text-xl font-extrabold tracking-tight text-ink',
            wrap ? 'break-words' : 'truncate',
          )}
        >
          {title}
        </h2>
      </div>
      {to && (
        <Link
          to={to}
          className="inline-flex shrink-0 items-center gap-0.5 text-sm font-bold text-primary-strong transition-all duration-200 hover:underline"
        >
          {seeAllLabel}
          <ChevronRight size={16} aria-hidden="true" />
        </Link>
      )}
    </div>
  );
}
